import { sbToastr } from 'shipbob_design_system';
import { getAuthService } from '@/auth';
import axios from 'axios';

export class HttpClient {
  get(url, requestConfig = {}) {
    return this._request({ method: 'GET', url, requestConfig });
  }

  post(url, data, requestConfig = {}) {
    return this._request({ method: 'POST', url, data, requestConfig });
  }

  put(url, data, requestConfig = {}) {
    return this._request({ method: 'PUT', url, data, requestConfig });
  }

  delete(url, data, requestConfig = {}) {
    return this._request({ method: 'DELETE', url, data, requestConfig });
  }

  async _request({ method, url, data, requestConfig }) {
    const authService = await getAuthService(null);
    const access_token = await authService.getToken();
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    return axios
      .request({
        url: url,
        method,
        data,
        headers,
        params: requestConfig.params,
      })
      .catch(async (error) => {
        if (error.response.status == 401) {
          sbToastr.error('Unauthorized, please log in again!');
          await authService.logout();
        }

        throw error;
      });
  }
}
